import AnalyticsEvent from './AnalyticsEvent';

export const AnalyticsEventBeforeLoggedIn = [
  AnalyticsEvent.click_sign_up,
  AnalyticsEvent.hit_register_page,
  AnalyticsEvent.input_fullname,
  AnalyticsEvent.input_brandname,
  AnalyticsEvent.input_username,
  AnalyticsEvent.input_phonenumber,
  AnalyticsEvent.input_email,
  AnalyticsEvent.input_password,
  AnalyticsEvent.click_here_referral,
  AnalyticsEvent.input_referral_code,
  AnalyticsEvent.click_register_account,
  AnalyticsEvent.hit_login_page,
  AnalyticsEvent.click_request_otp,
  AnalyticsEvent.tick_remember_this_device,
  AnalyticsEvent.click_login,
];
